import {Identifiable} from "./interface/Identifiable";

export class Customer implements Identifiable {
    constructor(
        readonly id: number | string,
        public name: string,
    ) {
    }

}